import React from 'react';
import { Box } from '@mui/material';
import ContactHeader from '../../components/contact/ContactHeader';
import ContactForm from '../../components/contact/ContactForm';
import { Location, useLocation } from 'react-router-dom';

/**
 * Contact page view for logged out potential users.
 * @returns {JSX.Element}
 */
const ExternalContactPage = () => {
  const location: Location = useLocation();

  // Auto-scroll to top of component when navigation from another page.
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 12
      }}
    >
      <ContactHeader title="Contact the Energy Partners Team" />
      <Box width={{ xs: '100%', lg: '70%' }}>
        <ContactForm user={null} company={null} />
      </Box>
    </Box>
  );
};

export default ExternalContactPage;
